import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { Pencil, ArrowLeft } from "lucide-react";

function EditCategory() {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get(`/categories/${id}`)
      .then((res) => {
        setName(res.data.name);
        setDescription(res.data.description || "");
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    // ✅ Validaciones frontend
    if (!name.trim()) {
      newErrors.name = "El nombre es obligatorio";
    }
    if (description.length > 255) {
      newErrors.description =
        "La descripción no puede tener más de 255 caracteres";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await api.put(`/categories/${id}`, {
        name,
        description,
      });

      toast.success("Categoría actualizada con éxito");
      navigate("/categories");
    } catch (error) {
      console.error("Error al actualizar categoría", error);

      if (error.response && error.response.data) {
        const data = error.response.data;
        let backendErrors = {};

        if (data.errors && Array.isArray(data.errors)) {
          data.errors.forEach((err) => {
            backendErrors[err.path] = err.msg;
          });
        } else if (data.error) {
          backendErrors.name = data.error;
        } else {
          backendErrors.general = "Ocurrió un error inesperado";
        }

        setErrors(backendErrors);
      } else {
        setErrors({ general: "No se pudo conectar al servidor" });
      }
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
      <button
        onClick={() => navigate("/categories")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Volver a Categorías
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6">
        Editar Categoría
      </h2>

      {errors.general && (
        <div className="text-red-600 mb-4 text-sm">{errors.general}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre
          </label>
          <input
            type="text"
            placeholder="Nombre de la categoría"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 
              ${errors.name ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-yellow-500"}`}
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Descripción
          </label>
          <textarea
            placeholder="Descripción de la categoría"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg h-28 resize-none focus:outline-none focus:ring-2 
              ${errors.description ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-yellow-500"}`}
          ></textarea>
          {errors.description && (
            <p className="text-red-500 text-sm mt-1">{errors.description}</p>
          )}
        </div>

        <button
          type="submit"
          className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-5 py-2 rounded-lg shadow transition duration-300"
        >
          <Pencil size={18} />
          Guardar Cambios
        </button>
      </form>
    </div>
  );
}

export default EditCategory;
